// extracted by mini-css-extract-plugin
module.exports = {"vouchersList":"VouchersList_vouchersList__cUz4r","addVoucherButton":"VouchersList_addVoucherButton___-y75"};